module.exports = __webpack_public_path__ + "05_short_gold.f75d4bb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/05_short_gold.png
// module id = +Gk9
// module chunks = 0